import React from 'react';
import './ChampionGrid.css';
import { useChampions } from '../hooks/useChampions';

interface ChampionGridProps {
  onSelectChampion: (championId: string) => void;
}

const ChampionGrid: React.FC<ChampionGridProps> = ({ onSelectChampion }) => {
  const { championsList, loading } = useChampions();

  if (loading) {
    return null;
  }

  // Filter out the practice dummy from the grid display
  const displayChampions = championsList.filter(c => c.id !== 'DummyChampion');

  return (
    <div className="champion-grid-container">
      <div className="champion-grid-scroll">
        <div className="champion-grid-scroll-inner">
        <div className="champion-grid">
          {displayChampions.map((champion) => (
            <div
              key={champion.id}
              className="champion-grid-item"
              onClick={() => onSelectChampion(champion.id)}
            >
              <div className="champion-image-container">
                <img
                  src={champion.imageUrl}
                  alt={champion.name}
                  className="champion-image"
                  loading="lazy"
                />
              </div>
              <span className="champion-name">{champion.name}</span>
            </div>
          ))}
        </div>
        </div>
      </div>
    </div>
  );
};

export default ChampionGrid;
